export function scrollWindow( options?: ScrollToOptions ): void {
    window.scrollTo( options );
}
